import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'

interface MetricCardProps {
  title: string
  value: React.ReactNode
  icon: React.ReactNode
  trend?: string
  rightValue?: React.ReactNode
  color?: string
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  trend,
  rightValue,
  color = 'primary',
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        px: 1.5,
        py: 1,
        height: '100%',
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.subtle',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Typography variant='caption' color='text.secondary' sx={{ minWidth: 0, lineHeight: 1.3 }}>
          {title}
        </Typography>
        <Box sx={{ color: `${color}.main`, display: 'flex', flexShrink: 0, '& .MuiSvgIcon-root': { fontSize: 18 } }}>
          {icon}
        </Box>
      </Box>
      <Box
        sx={{
          mt: 0.25,
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Typography
          component='div'
          variant='subtitle1'
          fontWeight={600}
          sx={{ fontVariantNumeric: 'tabular-nums', lineHeight: 1.25, minWidth: 0, overflowWrap: 'anywhere' }}
        >
          {value}
        </Typography>
        {rightValue ? (
          <Typography variant='caption' color='text.secondary' sx={{ whiteSpace: 'nowrap' }}>
            {rightValue}
          </Typography>
        ) : null}
      </Box>
      {trend ? (
        <Typography
          variant='caption'
          color='success.main'
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}
        >
          <TrendingUpIcon sx={{ fontSize: 16 }} />
          {trend}
        </Typography>
      ) : null}
    </Paper>
  )
}

export default MetricCard
